import React, { FC } from 'react';
import { Grid } from 'enova-frontend-components';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { LoadingIndicator } from '../../../loadingIndicator';
import { AllRegistrationScreenParams } from '../../../../utils/navigation'; // This is a hack to generate floors in the client. This should be moved to backend.
import { useSoknadSubmit } from '../../../../screens/soknad/hooks/useSoknadSubmit';
import useBuildingDetails from '../../../../hooks/useBuildingDetails';
import { getRegistrationId } from '../../../../screens/soknad/utils';
import { SoknadSteg } from '../../utils/registerEnums';
import useStore from '../../../../hooks/useStore';
import { Energimerkeversjon } from '../../../../types/energimerke';

import { AboutFormData } from './form/types';
import { fromUserInputToFormData } from './form/utils';
import { useAboutStateUpdate } from './hooks/useAboutStateUpdate';
import { SoknadAboutForm } from './form/soknadAboutForm';

const SoknadBase: FC = () => {
  const { t } = useTranslation();
  const store = useStore();
  const { isLoading: isSubmitting, onSoknadSubmit } = useSoknadSubmit();
  const { soknadSteg } = useParams<AllRegistrationScreenParams>();
  const { building } = useBuildingDetails();
  const { updateAboutState } = useAboutStateUpdate();

  const registrationId = getRegistrationId(soknadSteg || SoknadSteg.Steg1, building?.gyldigSoknad);

  const onAboutSubmit = (data: AboutFormData) => {
    updateAboutState(data);
    onSoknadSubmit(data.energimerkeversjon, registrationId);
  };

  const formData = fromUserInputToFormData({
    userInput: store.getState().register.userInput,
    registreringId: registrationId,
    soknadSteg: soknadSteg,
    // Soknad does only support V2023
    energimerkeversjon: Energimerkeversjon.V2023
  });

  if (isSubmitting) {
    return <LoadingIndicator text={t('save.loading')} />;
  }

  return (
    <Grid container spacing={4}>
      <SoknadAboutForm defaultValues={formData} onSubmit={onAboutSubmit} />
    </Grid>
  );
};

export default SoknadBase;
